document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-member-swiper]').forEach((root) => {
    const swiperEl = root.querySelector('.swiper');
    const prevEl = root.querySelector('.member-swiper-prev');
    const nextEl = root.querySelector('.member-swiper-next');
    if (!swiperEl) return;

    const getEdge = () => {
      const v = getComputedStyle(root).getPropertyValue('--member-edge-space').trim();
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.4,
      spaceBetween: 24,
      watchOverflow: true,
      navigation: { prevEl, nextEl },

      // ★端だけ余白
      slidesOffsetBefore: getEdge(),
      slidesOffsetAfter: getEdge(),

      breakpoints: {
        750: { slidesPerView: 3.2, spaceBetween: 32 },
        990: { slidesPerView: 3.2, spaceBetween: 40 },
        1200:{ slidesPerView: 4.2, spaceBetween: 40 },
      },
    });

    // 画面幅変更で余白も追従
    window.addEventListener('resize', () => {
      const edge = getEdge();
      swiper.params.slidesOffsetBefore = edge;
      swiper.params.slidesOffsetAfter = edge;
      swiper.update();
    });
  });
});
